import React, { memo } from 'react'

import { Progress } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

function ProgressBar({ label, used, total }) {
  const safeTotal = total > 0 ? total : 0
  const safeUsed = Math.max(0, Math.min(used, safeTotal))
  const percent = safeTotal === 0 ? 0 : Math.round((safeUsed / safeTotal) * 100)

  return (
    <div
      className="usage-modal__progress"
      role="progressbar"
      aria-label={label}
      aria-valuenow={safeUsed}
      aria-valuemin={0}
      aria-valuemax={safeTotal}
    >
      <div className="usage-modal__progress-row">
        <span className="usage-modal__progress-label cgt-body-base">{label}</span>
        <span className="usage-modal__progress-count cgt-body-base-semibold">
          {`${safeUsed}/${safeTotal}`}
        </span>
      </div>
      <Progress progress={percent} height={12} isSpaced={false} useGradient />
    </div>
  )
}

ProgressBar.propTypes = {
  label: string.isRequired,
  used: number.isRequired,
  total: number.isRequired,
}

export default memo(ProgressBar)
